export default __webpack_public_path__ + "static/media/contact-us-banner.ca5cec18.jpg";